import React from "react";
import ContactForm from "components/contact/form";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import PhoneLink from "components/elements/phone-link";
import Svg from "components/elements/svg";

const Contact = () => (
  <Layout className="contact" title="Contact">
    <Header>
      <HeaderBanner
        title="Contact"
        icon="contact-page"
        background="/static/images/header-contact.jpg"
      />
    </Header>
    <Breadcrumbs>
      <Breadcrumbs.Item title="Contact" url="contact" />
    </Breadcrumbs>
    <main className="contact__content container">
      <div className="row">
        <div className="col-xs-12 col-md-4">
          <h2 className="section-heading">Contact details</h2>
          <div className="details-row">
            <p className="bold">Hammer Price Homes Limited</p>
            <p>102 Chapel Lane</p>
            <p>Wigan</p>
            <p>WN3 4HG</p>
          </div>
          <div className="details-row">
            <p className="bold">Office hours are:</p>
            <p>Monday - Thursday: 9 AM - 5.15 PM</p>
            <p>Friday: 9 AM - 4 PM</p>
            <p>(excluding bank holidays).</p>
          </div>
          <div className="details-row">
            <p>
              <PhoneLink>
                <Svg className="icon" src="phone" />
              </PhoneLink>
            </p>
            <p>
              <a href="mailto:info@hammerpricehomes.co.uk">
                <Svg className="icon" src="envelope" />
                info@hammerpricehomes.co.uk
              </a>
            </p>
          </div>
          <div className="details-row">
            <p>Company Registration No: 08819923</p>
            <p>VAT Registration No: 206 1357 41</p>
            <p>MLR Registration No: 12818228</p>
          </div>
          <div className="details-row">
            <p>
              <a
                href="/static/files/complaints-procedure-v1.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Svg className="icon" src="message-bubble" />
                Complaints procedure
              </a>
            </p>
          </div>
        </div>
        <div className="col-xs-12 col-md-8">
          <ContactForm />
        </div>
      </div>
    </main>
  </Layout>
);

export default asPage(Contact);
